// extracted by mini-css-extract-plugin
export default {"banner":"noratingsbanner_banner__xMP9H","contentBanner":"noratingsbanner_contentBanner__-Ro3a"};